export const formFields = {
  login: {
    userName: 'userName',
    password: 'password',
  },

  register: {
    fullname: 'email',
    password: 'password',
  },
};
